import { camelCase as $camelCase, toLower as $toLower, toUpper as $toUpper, isEqual as $isEqual, upperFirst as $upperFirst, lowerFirst as $lowerFirst, merge as $merge, clone as $deepClone, debounce as $debounce, get as $lodashGet, set as $lodashSet } from "lodash";

// lodash方法
export { $camelCase, $toLower, $toUpper, $isEqual, $upperFirst, $lowerFirst, $merge, $deepClone, $debounce, $lodashGet, $lodashSet };

// 空对象判断
export function $isEmptyObject(obj) {
  for (const name in obj) {
    return false;
  }
  return true;
}

// 是否有属性key
export const $hasOwnProperty = (obj, key) => obj.hasOwnProperty(key);

// 为空判断
export function $isNullOrEmpty(obj) {
  return (obj !== 0 || obj !== "0") && (obj === null || obj === undefined || obj === "" || obj === "null" || typeof obj === "undefined");
}

// 是否为对象
export function $isObject(obj) {
  return obj !== null && typeof obj === "object";
}

// 纯对象
export function $isRealObject(obj) {
  return !!obj && Object.prototype.toString.call(obj) === "[object Object]";
}

// formData
export function $isFormData(obj) {
  return !!obj && Object.prototype.toString.call(obj) === "[object FormData]";
}

// 函数
export function $isFunction(obj) {
  return !!obj && Object.prototype.toString.call(obj) === "[object Function]";
}

// 字符串
export function $isString(str) {
  return Object.prototype.toString.call(str) === "[object String]";
}

// 空数组
export function $isEmptyArr(arr) {
  return Array.isArray(arr) && arr.length === 0;
}

// 判断字符串是否为纯数字
export function $isNumber(string) {
  // isNaN()的缺点就在于 null、空串会被按照0来处理
  return string !== null && string !== "" && !isNaN(string);
}

export function $isEmpty(str) {
  return str === null || str === "" || str === "undefined" || str === undefined;
}

export function $isPromise(val) {
  return $isObject(val) && $isFunction(val.then) && $isFunction(val.catch);
}

/**
 * $setJsonValue(this.json, 'formItem[0].attribute.disabled', true)
 */
export function $setJsonValue(data, key, value) {
  $lodashSet(data, key, value);
}

/**
 * $setJsonValue(this.json.formItem, 'attribute.disabled', true, 'prop')
 */
export function $setFormItemValue(data, key, value, prop) {
  let temp;
  if (Array.isArray(data)) {
    temp = data.find((item) => item.prop === prop);
  } else if (Array.isArray(data.formItem)) {
    temp = data.formItem.find((item) => item.prop === prop);
  }

  if (temp) {
    $lodashSet(temp, key, value);
  }
}
